import { createAuth0 } from '@auth0/auth0-vue';
import {isPlatform} from "@ionic/vue";
import { env } from "@/env";

const auth0 = createAuth0({
    domain: (isPlatform("capacitor") ? env.AUTH0_DOMAIN : env.AUTH0_DOMAIN_BRANDED) || '',
    clientId: env.AUTH0_CLIENTID || '',
    authorizationParams: {
        redirect_uri: isPlatform("capacitor")
            ? env.AUTH0_CAPCALLBACK
            : window.location.origin,
        audience: env.AUTH0_AUDIENCE,
    },
    cacheLocation: 'localstorage',
    useRefreshTokens: true,
    useRefreshTokensFallback: true,
});

export default auth0;
